import { css, html, LitElement } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
// import '../ChatTile/ChatTile';
import '../ContactTile/ContactTile';
import { Image } from '../Image/Image';
import './MediaList';
import { generateProfileImageByInitials } from '../../../lib/helpers';
import { WEB_CONTENT } from '../../../constants/content';
import '../MembersList/MembersList';
import { groupMembersStore } from '../../../store/group-members';
import videoPlaceholder from '../../../assets/images/videoPlaceholder.svg';
import imagePlaceholder from '../../../assets/images/imagePlaceholder.svg';
import '../../../stories/Components/MessageBubble/LinkMessageBubble/LinkMessageBubble';
import { drawerDialogService } from '../Dialog-Drawer/dialog-drawer';
class PofileInfo extends LitElement {
  static properties = {
    //strings
    padding: { type: String },
    margin: { type: String },
    width: { type: String },
    boxShadow: { type: String },
    height: { type: String },
    borderRadius: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },
    backgroundColor: { type: String },
    textColor: { type: String },
    fontSize: { type: String },
    fontWeight: { type: String },
    fontFamily: { type: String },
    fontStyle: { type: String },
    lineHeight: { type: String },
    textAlign: { type: String },
    contactImage: { type: String },
    contactName: { type: String },
    contactEmail: { type: String },
    messageAction: { type: Object },

    //arrays
    groupMembers: { type: Array },
    allAttachments: { type: Array },

    //booleans
    isGroup: { type: Boolean },
    showAllMembers: { type: Boolean },
    isPopupOpen: { type: Boolean },
    showMediaList: { type: Boolean },
    isImageFullscreen: { type: Boolean },
    showConfirmationPopup: { type: Boolean },
    confirmationAction: { type: String },
    conversationId: { type: String, reflect: true, mutable: true },
    oppenentId: { type: String, reflect: true },
    userMetaData: { type: Object },
    onEditTitle: { type: Function },
    handleChatSelect: { type: Function },
    onEditImage: { type: Function },
    isEditingName: { type: Boolean },
    onEditImage: { type: Function },
    openOwnProfile: { type: Boolean },
    editedName: { type: String },
    eligibleMembers: { type: Array },
    isEligibleMembersPopupOpen: { type: Boolean },
    hasMoreEligibleMembers: { type: Boolean },
    isLoadingMembers: { type: Boolean },
    activeTab: { type: String },
    docsAttachments: { type: Array },
    linksAttachments: { type: Array },
    allLinks: { type: Array },
    allLinksCount: { type: Number },
    isBlocked: { type: Boolean | String },
    conversationMetaData: { type: Object },
  };

  static styles = css`
    .contact-info-container {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
    }

    .contact-info-header {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 20px;
      font-size: 18px;
      background: inherit;
      position: sticky;
      top: 0;
      z-index: 10;
      background: var(--bg-primary-color);
    }
    .shimmer-loader {
      width: 50%;
      height: 40px;
      position: relative;
      overflow: hidden;
    }

    .shimmer-line {
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, var(--bg-secondary-color) 25%, var(--bg-primary-light) 50%, var(--bg-secondary-color) 75%);
      animation: shimmer 1.5s infinite;
    }

    @keyframes shimmer {
      0% {
        left: -100%;
      }
      100% {
        left: 100%;
      }
    }

    .contact-info-body {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      background: inherit;
      overflow-y: auto;
      flex-grow: 1;
    }

    .contact-info-body::-webkit-scrollbar {
      width: 4px;
    }

    .contact-info-body::-webkit-scrollbar-thumb {
      background-color: var(--text-primary-color);
      border-radius: 10px;
    }

    .contact-info-body::-webkit-scrollbar-track {
      background: var(--bg-primary-color);
      border-radius: 10px;
    }

    .contact-info {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-direction: column;
      padding: 1.5rem;
    }

    .contact-info-name {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .contact-info-name span:first-child {
      font-size: 20px;
      font-weight: 600;
    }

    .contact-info-name span:last-child {
      font-size: 16px;
      font-weight: 400;
    }

    .contact-media {
      padding: 16px;
      background: inherit;
    }

    .contact-media-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 18px;
    }
    contact-media-header-label {
      font-size: 14px;
    }

    .contact-media-header-count {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .contact-media-body {
      display: flex;
      gap: 10px;
      overflow: hidden;
      padding: 10px;
    }
    .members-list {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1000;
      width: 25%;
      min-width: var(--sidebar-width);
    }

    .popup-members {
      display: flex;
      flex-direction: column;
      gap: 10px;
      max-height: calc(80vh - 50px);
      overflow-y: auto;
    }

    .popup-members::-webkit-scrollbar {
      width: 4px;
    }

    .popup-members::-webkit-scrollbar-track {
      background: transparent;
    }

    .popup-members::-webkit-scrollbar-thumb {
      background-color: var(--bg-primary-light);
      border-radius: 3px;
    }

    .group-members-popup-actions {
      display: flex;
      align-items: center;
      gap: 10px;
      position: absolute;
      bottom: 0px;
      background: var(--bg-secondary-color);
      z-index: 1;
      padding: 10px;
      left: 0;
      margin: 10px;
      width: -webkit-fill-available;
      justify-content: center;
      cursor: pointer;
    }

    .group-members-popup {
      position: relative;
    }

    .group-members-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0px 16px;
    }

    .group-members-header svg {
      cursor: pointer;
    }

    .group-members {
      padding: 16px;
      background: inherit;
    }

    .close-btn {
      background: none;
      border: none;
      font-size: 24px;
      cursor: pointer;
    }

    .ctas {
      display: flex;
      flex-direction: column;
      gap: 2px;
      background: var(--bg-primary-color);
    }

    .ctas button {
      border: none;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 20px;
      cursor: pointer;
      width: 100%;
      font-size: 16px;
      background: transparent;
    }

    .ctas button:hover {
      background: var(--bg-secondary-color);
    }

    .fullscreen-image-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
    }

    .fullscreen-image-container img {
      position: relative;
    }

    .contact-media-body img {
      cursor: pointer;
    }

    .contact-media-body img:hover {
      scale: 1.05;
    }

    .group-members chat-tile:hover {
      background: var(--bg-primary-light);
      cursor: pointer;
      border-radius: 8px;
    }

    .popup-members chat-tile:hover {
      background: var(--bg-primary-light);
      cursor: pointer;
      border-radius: 8px;
    }

    .profile-image-container {
      position: relative;
      cursor: pointer;
    }

    .profile-image-container:hover .image-edit-overlay {
      opacity: 1;
    }

    .image-edit-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    .name-edit-input:focus {
      background: var(--bg-primary-light);
    }

    .nav-container {
      width: 100%;
      background-color: var(--bg-secondary-color);
      padding: 16px 0;
    }
    .messageTab {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 10px 0px;
      color: var(--bg-incoming-message);
      cursor: pointer;
    }
    /* Inner container for max width */
    .inner-container {
      max-width: 1024px;
      margin: 0 auto;
      padding: 0 16px;
    }

    /* Tab styling */
    .tabs {
      display: flex;
      gap: 32px;
    }

    /* Tab item styling */
    .tab-item {
      position: relative;
      cursor: pointer;
    }

    /* Radio buttons (hidden) */
    .tab-radio {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }

    /* Tab labels */
    .tab-label {
      display: inline-block;
      color: #9ca3af;
      font-size: 18px;
      padding: 4px 0;
      transition: color 0.3s ease;
    }

    /* Underline indicator */
    .tab-indicator {
      position: absolute;
      bottom: -16px;
      left: 0;
      width: 100%;
      height: 4px;
      background-color: var(--base-color);
      transform: scaleX(0);
      transition: transform 0.3s ease;
    }

    /* When radio is checked */
    .tab-radio:checked + .tab-label {
      color: var(--base-color);
    }

    .tab-radio:checked ~ .tab-indicator {
      transform: scaleX(1);
    }

    /* Focus styles for accessibility */
    .tab-radio:focus + .tab-label {
      outline-offset: 2px;
    }
    .doc-item {
      display: flex;
      align-items: center;
      background: var(--bg-primary-light);
      margin: 8px 0;
      padding: 12px;
      border-radius: 8px;
      cursor: pointer;
    }

    .doc-item:hover {
      background: var(--bg-secondary-color);
    }

    .doc-icon {
      margin-right: 12px;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .doc-info {
      flex-grow: 1;
      overflow: hidden;
    }

    .doc-name {
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 4px;
    }

    .doc-meta {
      display: flex;
      font-size: 12px;
      color: var(--text-secondary-color);
    }

    /* Link item styles */
    .link-item {
      display: flex;
      margin: 8px 0;
      border-radius: 8px;
      overflow: hidden;
      text-decoration: none;
      color: inherit;
    }

    .link-item:hover {
      background: var(--bg-secondary-color);
    }

    .link-preview {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .link-info {
      padding: 12px;
      flex-grow: 1;
      overflow: hidden;
    }

    .link-title {
      font-weight: 500;
      margin-bottom: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .link-url {
      font-size: 12px;
      color: var(--text-secondary-color);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .no-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 200px;
      color: var(--text-secondary-color);
      text-align: center;
      padding: 0 20px;
    }

    .no-content svg {
      margin-bottom: 16px;
      opacity: 0.5;
    }

    /* Month separator */
    .month-separator {
      font-size: 14px;
      font-weight: 500;
      margin: 24px 0 12px 0;
      padding-left: 8px;
    }

    .shimmer {
      background: linear-gradient(90deg, var(--bg-secondary-color) 25%, var(--bg-primary-light) 50%, var(--bg-secondary-color) 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite linear;
    }

    .member-shimmer {
      height: 60px;
      border-radius: 8px;
      margin: 8px 16px;
      opacity: 0.7;
    }

    @keyframes shimmer {
      0% {
        background-position: 100% 0;
      }
      100% {
        background-position: -100% 0;
      }
    }
  `;

  constructor() {
    super();
    this.lastConversationId = null;
    this.isEditingName = false;
    this.editedName = '';
    this.isLoadingMembers = true;
    this.activeTab = 'media';
    this.conversationMetaData = {};

    // Sample data for docs and links
    this.docsAttachments = [];
    this.linksAttachments = [];
  }
  willUpdate(changedProperties) {
    if (changedProperties.has('conversationId')) {
      this.handleConversationIdChange(this.conversationId, changedProperties.get('conversationId'));
    }
  }

  handleConversationIdChange(newValue, oldValue) {
    if (newValue !== groupMembersStore.getCurrentConversationId()) {
      this.isLoadingMembers = true;
      groupMembersStore.initializeMembers(this.groupMembers, newValue);
    }

    const newConversationId = this.getConversationIdFromUrl();
    if (this.lastConversationId && this.lastConversationId !== newConversationId) {
      this._handleClose();
    }

    this.lastConversationId = newConversationId;
  }

  toggleShowAllMembers() {
    this.showAllMembers = !this.showAllMembers;
  }

  showMembersPopup() {
    this.isPopupOpen = true;
  }

  closeMembersPopup() {
    this.isPopupOpen = false;
  }

  toggleMediaList() {
    this.showMediaList = !this.showMediaList;
  }

  toggleImageFullscreen() {
    this.isImageFullscreen = !this.isImageFullscreen;
  }

  _handleClose() {
    if (this.showMediaList) {
      this.showMediaList = false;
      return;
    }
    this.dispatchEvent(
      new CustomEvent('close-right-Sidebar', {
        detail: {
          type: 'close-right-Sidebar',
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  getConversationIdFromUrl() {
    const url = new URL(window.location.href);
    return url.searchParams.get('conversation');
  }

  exitGroup() {
    this.dispatchEvent(
      new CustomEvent('contact-action', {
        detail: {
          action: 'exit-group',
          conversationId: this.conversationId,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  clearChat() {
    this.dispatchEvent(
      new CustomEvent('contact-action', {
        detail: {
          action: 'clear-chat',
          conversationId: this.conversationId,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  blockContact() {
    this.dispatchEvent(
      new CustomEvent('contact-action', {
        detail: {
          action: 'block-contact',
          oppenentId: this.oppenentId,
          userName: this.contactName,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }
  unblockContact() {
    this.dispatchEvent(
      new CustomEvent('contact-action', {
        detail: {
          action: 'unblock-contact',
          oppenentId: this.oppenentId,
          userName: this.contactName,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  deleteChat() {
    this.dispatchEvent(
      new CustomEvent('contact-action', {
        detail: {
          action: 'delete-chat',
          conversationId: this.conversationId,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  openConfirmationPopup(action) {
    drawerDialogService.openDialog('confirm-dialog', {
      title: `${title}`,
      description: `Are you sure you want to ${title} ?`,
      handleConfirm: () => this.confirmAction(action),
    });
  }

  closeConfirmationPopup() {
    this.showConfirmationPopup = false;
    this._handleClose();
  }

  confirmAction(action) {
    switch (action) {
      case 'delete-chat':
        this.deleteChat();
        break;
      case 'exit-group':
        this.exitGroup();
        break;
      case 'clear-chat':
        this.clearChat();
        break;
      case 'block-contact':
        this.blockContact();
        break;
      case 'unblock-contact':
        this.unblockContact();
        break;
      // Add more cases if needed
    }
    this.closeConfirmationPopup();
  }

  _handleKebabMenuClick(e) {
    e.stopPropagation();
  }

  shouldShowMemberActions(memberId) {
    const currentUserMember = this.groupMembers?.find(m => m.userId === this.userMetaData?.userId);
    return currentUserMember?.isAdmin ? this.userMetaData?.userId !== memberId : false;
  }

  handleNameClick() {
    if (this.isGroup) {
      this.isEditingName = true;
      this.editedName = this.contactName;
      setTimeout(() => {
        const input = this.shadowRoot.querySelector('.name-edit-input');
        if (input) {
          input.focus();
          input.select();
        }
      }, 0);
    }
  }

  handleNameInputKeyDown(e) {
    if (e.key === 'Enter') {
      this.saveName();
    } else if (e.key === 'Escape') {
      this.isEditingName = false;
    }
  }

  saveName() {
    if (this.editedName.trim() && this.editedName !== this.contactName) {
      const oldName = this.contactName;
      this.contactName = this.editedName.trim();

      this.dispatchEvent(
        new CustomEvent('edit-title', {
          detail: {
            currentTitle: oldName,
            newTitle: this.editedName.trim(),
            conversationId: this.conversationId,
            onError: () => {
              // Revert on error
              this.contactName = oldName;
            },
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
    this.isEditingName = false;
  }

  handleImageClick() {
    if (this.isGroup) {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.onchange = e => {
        const file = e.target.files?.[0];
        if (file) {
          const tempImageUrl = URL.createObjectURL(file);
          const oldImage = this.contactImage;

          this.contactImage = tempImageUrl;

          this.dispatchEvent(
            new CustomEvent('edit-image', {
              detail: {
                currentImage: oldImage,
                conversationId: this.conversationId,
                file: file,
                onError: () => {
                  this.contactImage = oldImage;
                  URL.revokeObjectURL(tempImageUrl);
                },
                onSuccess: () => {
                  URL.revokeObjectURL(tempImageUrl);
                },
              },
              bubbles: true,
              composed: true,
            }),
          );
        }
      };
      input.click();
    }
  }

  extractAttachmentsByType() {
    // Reset arrays
    this.docsAttachments = [];
    this.linksAttachments = [];
    if (!this.allAttachments || !this.allAttachments.length) return;
    this.allAttachments.forEach(attachment => {
      attachment?.attachments?.forEach(att => {
        if (att.mediaType === 3) {
          // Document type
          this.docsAttachments.push({
            ...att,
            date: attachment.sentAt,
            sender: attachment?.senderInfo?.userName,
          });
        } else if (attachment?.customType === 'AttachmentMessage:Link') {
          // Link type
          this.linksAttachments.push({
            ...att,
            date: attachment.sentAt,
            sender: attachment?.senderInfo?.userName,
          });
        }
      });
    });

    // Sort by date
    this.docsAttachments.sort((a, b) => new Date(b.date) - new Date(a.date));
    this.linksAttachments.sort((a, b) => new Date(b.date) - new Date(a.date));

    this.requestUpdate();
  }

  updated(changedProperties) {
    // Existing updated logic
    super.updated(changedProperties);

    // Add extraction of docs and links when attachments are updated
    if (changedProperties.has('allAttachments')) {
      this.extractAttachmentsByType();
    }
  }

  switchTab(tab) {
    this.activeTab = tab;
  }

  formatFileSize(bytes) {
    if (!bytes) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  formatDate(timestamp) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  getMonthYear(timestamp) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }

  groupByMonth(items, isLinks = false) {
    const groups = {};
    items.forEach(item => {
      const monthYear = this.getMonthYear(isLinks ? item.sentAt : item.date);
      if (!groups[monthYear]) {
        groups[monthYear] = [];
      }
      groups[monthYear].push(item);
    });

    return groups;
  }

  handleRedirectChat() {
    if (this.conversationId) {
      this.handleChatSelect(this.conversationId);
    }
    this.dispatchEvent(
      new CustomEvent('close-right-Sidebar', {
        detail: {
          type: 'close-right-Sidebar',
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  renderNoContent(title, subtitle) {
    return html`
      <div class="tab-content active">
        <div class="no-content">
          <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 0 24 24" width="48" fill="currentColor">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z" />
          </svg>
          <h3 style="margin: 0 0 8px 0;">${title}</h3>
          <p style="margin: 0;">${subtitle}</p>
        </div>
      </div>
    `;
  }

  renderTabContent() {
    if (this.activeTab === 'media') {
      const mediaFromAttachments = [];
      this.allAttachments?.forEach(attachment => {
        attachment?.attachments?.forEach(att => {
          if (att?.mediaUrl && (att.mediaType === 0 || att.mediaType === 1)) {
            // Image/video type
            mediaFromAttachments.push(att.mediaUrl);
          }
        });
      });
      if (!mediaFromAttachments.length) {
        return this.renderNoContent('No Media', 'Share media with this chat to see them here.');
      }

      return html`
        <div class="tab-content active">
          <media-list
            .mediaArray=${mediaFromAttachments}
            padding="10px"
            bgColor=${this.backgroundColor}
            color=${this.textColor}
            style="width: 100%"
            borderRadius="10px"
            height="calc(100vh - 100px)"
          ></media-list>
        </div>
      `;
    } else if (this.activeTab === 'docs') {
      if (!this.docsAttachments.length) {
        return this.renderNoContent('No Documents', 'Share documents with this chat to see them here.');
      }

      const docsByMonth = this.groupByMonth(this.docsAttachments);

      return html`
        <div class="tab-content active">
          ${Object.keys(docsByMonth).map(
            month => html`
              <div class="month-separator">${month}</div>
              ${docsByMonth[month].map(
                doc => html`
                  <div class="doc-item" @click=${() => window.open(doc.mediaUrl, '_blank')}>
                    <div class="doc-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="currentColor">
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM16 18H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
                      </svg>
                    </div>
                    <div class="doc-info">
                      <div class="doc-name">${doc.name || 'Document'}</div>
                      <div class="doc-meta">
                        <span>${this.formatFileSize(doc.size)}</span>
                        <span style="margin: 0 6px;">•</span>
                        <span>${this.formatDate(doc.date)}</span>
                      </div>
                    </div>
                  </div>
                `,
              )}
            `,
          )}
        </div>
      `;
    } else if (this.activeTab === 'links') {
      if (!this.allLinks?.length) {
        return this.renderNoContent('No Links', 'URLs shared in this chat will appear here.');
      }

      const linksByMonth = this.groupByMonth(this.allLinks, true);

      return html`
        <div class="tab-content active">
          ${Object.keys(linksByMonth).map(
            month => html`
              <div class="month-separator">${month}</div>
              ${linksByMonth[month].map(
                link => html`
                  <a href=${link.body} target="_blank" class="link-item">
                    <div class="link-preview">
                      <link-preview url=${link.body} time=${link.sentAt}></link-preview>
                    </div>
                  </a>
                `,
              )}
            `,
          )}
        </div>
      `;
    }
  }

  render() {
    const headerFontSize = `calc(${this.fontSize} - 4px)`;
    const mediaFromAttachments = [];
    this.allAttachments?.forEach(attachment => {
      attachment?.attachments?.forEach(att => {
        if (att?.mediaUrl) {
          mediaFromAttachments.push(att.mediaUrl);
        }
      });
    });
    const members = groupMembersStore.getMembers();
    this.isLoadingMembers = !members;

    return html`
      <div
        class="contact-info-container"
        style=${styleMap({
          padding: this.padding,
          margin: this.margin,
          width: this.width,
          height: this.height,
          borderRadius: this.borderRadius,
          borderWidth: this.borderWidth,
          borderColor: this.borderColor,
          borderStyle: this.borderStyle,
          backgroundColor: this.backgroundColor,
          color: this.textColor,
          fontSize: this.fontSize,
          fontWeight: this.fontWeight,
          fontFamily: this.fontFamily,
          fontStyle: this.fontStyle,
          lineHeight: this.lineHeight,
          boxShadow: this.boxShadow,
          textAlign: this.textAlign,
        })}
      >
        ${this.showMediaList
          ? html`
              <div class="contact-info-header">
                <svg
                  @click=${this._handleClose}
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="${this.textColor}"
                  style="cursor: pointer;"
                >
                  <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                </svg>
              </div>
              <div>
                <div class="nav-container">
                  <div class="inner-container">
                    <div class="tabs">
                      <div class="tab-item">
                        <input type="radio" id="tab-media" name="tabs" class="tab-radio" ?checked=${this.activeTab === 'media'} @change=${() => this.switchTab('media')} />
                        <label for="tab-media" class="tab-label">Media</label>
                        <div class="tab-indicator" style="transform: ${this.activeTab === 'media' ? 'scaleX(1)' : 'scaleX(0)'}"></div>
                      </div>

                      <div class="tab-item">
                        <input type="radio" id="tab-docs" name="tabs" class="tab-radio" ?checked=${this.activeTab === 'docs'} @change=${() => this.switchTab('docs')} />
                        <label for="tab-docs" class="tab-label">Docs</label>
                        <div class="tab-indicator" style="transform: ${this.activeTab === 'docs' ? 'scaleX(1)' : 'scaleX(0)'}"></div>
                      </div>

                      <div class="tab-item">
                        <input
                          type="radio"
                          id="tab-links"
                          name="tabs"
                          class="tab-radio"
                          ?checked=${this.activeTab === 'links'}
                          @change=${() => this.switchTab('links')}
                          @click=${() =>
                            this.dispatchEvent(
                              new CustomEvent('get-links', {
                                detail: {
                                  conversationId: this.conversationId,
                                },
                                bubbles: true,
                                composed: true,
                              }),
                            )}
                        />
                        <label for="tab-links" class="tab-label">Links</label>
                        <div class="tab-indicator" style="transform: ${this.activeTab === 'links' ? 'scaleX(1)' : 'scaleX(0)'}"></div>
                      </div>
                    </div>
                  </div>
                </div>

                ${this.renderTabContent()}
              </div>
            `
          : html`
              <div class="contact-info-header">
                <svg
                  @click=${this._handleClose}
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="${this.textColor}"
                  style="cursor: pointer;"
                >
                  <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                </svg>
                ${html`<span class="contact-info-label">Contact Info</span>`}
              </div>

              <div class="contact-info-body">
                <div class="contact-info" style="background: var(--bg-primary-color);">
                  <div style="position: relative; display: flex; align-items: center; gap: 8px;">
                    ${Image({
                      src: this.contactImage,
                      alt: this.contactName,
                      width: 'calc(75dvh - 300px)',
                      height: 'calc(75dvh - 300px)',
                      borderRadius: '50%',
                      objectFit: 'cover',
                      placeholderImage: generateProfileImageByInitials(this.contactName),
                    })}
                  </div>
                  <div class="contact-info-name">
                    ${html` <span>${this.contactName}</span> `}
                    <span>${this.contactEmail}</span>
                    <span @click=${this.handleRedirectChat} class="messageTab">
                      <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="#3f51b5">
                        <path
                          d="M240-400h480v-66.67H240V-400Zm0-126.67h480v-66.66H240v66.66Zm0-126.66h480V-720H240v66.67ZM880-80 720-240H146.67q-27 0-46.84-19.83Q80-279.67 80-306.67v-506.66q0-27 19.83-46.84Q119.67-880 146.67-880h666.66q27 0 46.84 19.83Q880-840.33 880-813.33V-80ZM146.67-306.67h602l64.66 68.34v-575H146.67v506.66Zm0 0v-506.66 506.66Z"
                        />
                      </svg>
                      <span> ${WEB_CONTENT.PLACEHOLDER_CONTENT.SEARCH_CHAT.MESSAGE} </span>
                    </span>
                  </div>
                </div>

                <div class="contact-media" style="background: var(--bg-primary-color);">
                  <div class="contact-media-header">
                    <span class="contact-media-header-label">Media, links and docs</span>
                    <div class="contact-media-header-count" @click=${this.toggleMediaList}>
                      <span>${this.allLinksCount || this.allAttachments?.length}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="${this.textColor}">
                        <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            `}
        ${this.isEligibleMembersPopupOpen
          ? html`
              <div class="popup-overlay">
                <div class="members-list">
                  <members-list
                    .contactList=${this.eligibleMembers}
                    .onClosePopup=${() => (this.isEligibleMembersPopupOpen = false)}
                    label="Eligible Members"
                    width="100%"
                    fontSize="16px"
                    fontFamily="Arial, sans-serif"
                    .hasMoreEligibleMembers=${this.hasMoreEligibleMembers}
                  ></members-list>
                </div>
              </div>
            `
          : ''}

        <div class="ctas">
          ${this.showMediaList
            ? null
            : html`
                <button @click="${() => this.openConfirmationPopup('clear-chat')}">Clear Chat</button>
                ${this.conversationMetaData.messagingDisabled && this.isBlocked
                  ? html`<button style="color: red;" @click="${() => this.openConfirmationPopup('unblock-contact')}">Unblock Chat</button>`
                  : !this.conversationMetaData.messagingDisabled && this.isBlocked === null
                    ? html`<button style="color: red;" @click="${() => this.openConfirmationPopup('block-contact')}">Block Chat</button>`
                    : this.isBlocked === 'loading'
                      ? html`<div class="shimmer-loader">
                          <div class="shimmer-line"></div>
                        </div>`
                      : null}
                <button style="color: red;" @click="${() => this.openConfirmationPopup('delete-chat')}">Delete Chat</button>
              `}
        </div>
      </div>
    `;
  }
}

customElements.define('profile-info', PofileInfo);
